import React, { useEffect, useState, useCallback } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

export const ProtectedRoute = ({ children, requireSubscription = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [checkingSubscription, setCheckingSubscription] = useState(true);

  // Pages that don't require subscription
  const freePages = ['/assinatura', '/pagamento/sucesso', '/pagamento/cancelado'];
  const isFreePage = freePages.includes(location.pathname);

  const checkSubscription = useCallback(async () => {
    try {
      const response = await api.get('/subscription/my-subscription');
      setSubscriptionStatus(response.data);
    } catch (error) {
      setSubscriptionStatus({ has_subscription: false });
    } finally {
      setCheckingSubscription(false);
    }
  }, []);

  useEffect(() => {
    if (user && requireSubscription && !isFreePage) {
      checkSubscription();
    } else {
      setCheckingSubscription(false);
    }
  }, [user, requireSubscription, isFreePage, checkSubscription]);

  if (loading || checkingSubscription) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <div className="text-[#22C55E] text-xl font-heading">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If subscription check is required and user doesn't have active subscription
  if (requireSubscription && !isFreePage && subscriptionStatus && !subscriptionStatus.has_subscription) {
    return <Navigate to="/assinatura" replace />;
  }

  return children;
};